import React from 'react';

export default (props) => (
    <div className="edit-profile">
        <div className="edit-profile__block">
            <div className="profile-name">
                <div
                    className={props.validationErrors.first_name.status ? "text-field has-error" : "text-field"}
                >
                    <label className="text-field__label" htmlFor="first-name">First Name</label>
                    <input
                        className="text-field__input"
                        id="first-name"
                        type="text"
                        value={props.user.first_name}
                        onChange={(e) => props.handleChange('first_name', e.target.value)}
                        placeholder="First name"
                    />
                    <span className="error-message">{props.validationErrors.first_name.message}</span>
                </div>
                <div
                    className={props.validationErrors.last_name.status ? "text-field has-error" : "text-field"}
                >
                    <label className="text-field__label" htmlFor="last-name">Last Name</label>
                    <input
                        className="text-field__input"
                        id="last-name"
                        type="text"
                        value={props.user.last_name}
                        onChange={(e) => props.handleChange('last_name', e.target.value)}
                        placeholder="Last name"
                    />
                    <span className="error-message">{props.validationErrors.last_name.message}</span>
                </div>
            </div>
            <div
                className={props.validationErrors.business_name.status ? "text-field has-error" : "text-field"}
            >
                <label className="text-field__label" htmlFor="business-name">Business Name</label>
                <input
                    className="text-field__input"
                    id="business-name"
                    type="text"
                    value={props.user.business_name}
                    onChange={(e) => props.handleChange('business_name', e.target.value)}
                    placeholder="Business Name"
                />
                <span className="error-message">{props.validationErrors.business_name.message}</span>
            </div>
            <div
                className={props.validationErrors.business_email.status ? "text-field has-error" : "text-field"}
            >
                <label className="text-field__label" htmlFor="business-email">Business Email Address</label>
                <input
                    className="text-field__input"
                    id="business-email"
                    type="text"
                    value={props.user.business_email}
                    onChange={(e) => props.handleChange('business_email', e.target.value)}
                    placeholder="Business Email Address"
                />
                <span className="error-message">{props.validationErrors.business_email.message}</span>
            </div>
            <div
                className={props.validationErrors.business_phone.status ? "text-field has-error" : "text-field"}
            >
                <label className="text-field__label" htmlFor="business-phone">Business Phone</label>
                <input
                    className="text-field__input"
                    id="business-phone"
                    type="number"
                    value={props.user.business_phone}
                    onChange={(e) => props.handleChange('business_phone', e.target.value)}
                    placeholder="Business Phone Number"
                />
                <span className="error-message">{props.validationErrors.business_phone.message}</span>
            </div>
        </div>
        <div className="edit-profile__block">
            <div className={props.validationErrors.country.status ? "edit-select has-error" : "edit-select"}>
                <label>Country</label>
                <select
                    defaultValue={props.user.country}
                    className="form-control"
                    onChange={(e) => props.handleChange('country', e.target.value)}>
                    {props.countries.map((country, i) =>
                        <option
                            key={i}
                            value={country}>
                            {country}
                        </option>
                    )}
                </select>
                <span className="error-message">{props.validationErrors.country.message}</span>
            </div>
            <div
                className={props.validationErrors.street_address.status ? "text-field has-error" : "text-field"}
            >
                <label className="text-field__label" htmlFor="street">Street Address</label>
                <input
                    className="text-field__input"
                    id="street"
                    type="text"
                    value={props.user.street_address}
                    onChange={(e) => props.handleChange('street_address', e.target.value)}
                    placeholder="Street Address"
                />
                <span className="error-message">{props.validationErrors.street_address.message}</span>
            </div>
            <div className="location">
                <div
                    className={props.validationErrors.city.status ? "text-field has-error" : "text-field"}
                >
                    <label className="text-field__label" htmlFor="city">City</label>
                    <input
                        className="text-field__input"
                        id="city"
                        type="text"
                        value={props.user.city}
                        onChange={(e) => props.handleChange('city', e.target.value)}
                        placeholder="City"
                    />
                    <span className="error-message">{props.validationErrors.city.message}</span>
                </div>
                <div
                    className={props.validationErrors.zip_code.status ? "text-field has-error" : "text-field"}
                >
                    <label className="text-field__label" htmlFor="postal-code">Postal Code/zip</label>
                    <input
                        className="text-field__input"
                        id="postal-code"
                        type="text"
                        value={props.user.zip_code}
                        onChange={(e) => props.handleChange('zip_code', e.target.value)}
                        placeholder="Postal Code/zip"
                    />
                    <span className="error-message">{props.validationErrors.zip_code.message}</span>
                </div>
            </div>
            <div
                className="text-field"
            >
                <label className="text-field__label" htmlFor="license">License</label>
                <input
                    className="text-field__input"
                    id="license"
                    type="text"
                    value={props.user.license}
                    onChange={(e) => props.handleChange('license', e.target.value)}
                    placeholder="License (not required)"
                />
            </div>
            <div
                className={props.validationErrors.website.status ? "text-field has-error" : "text-field"}
            >
                <label className="text-field__label" htmlFor="website">Website</label>
                <input
                    className="text-field__input"
                    id="website"
                    type="text"
                    value={props.user.website}
                    onChange={(e) => props.handleChange('website', e.target.value)}
                    placeholder="Website (not required)"
                />
                <span className="error-message">{props.validationErrors.website.message}</span>
            </div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/Profile/edit.js